import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-yene-baki-jahirat-report',
  templateUrl: './yene-baki-jahirat-report.component.html',
  styleUrl: './yene-baki-jahirat-report.component.scss'
})
export class YeneBakiJahiratReportComponent implements OnInit {

  reportType: any;
  startDate: any;
  endDate: any;
  repName: any;
  offRepName: any;
  currentDate: Date = new Date();
  isLoading = true;

  // ── Dynamically built from API response ──────────────────────────────────
  allYears: string[] = [];
  earlyYears: string[] = [];   // years BEFORE 2021-22
  recentYears: string[] = [];   // years FROM 2021-22 onwards

  // ── Same structure the original HTML expects ──────────────────────────────
  // onlyOutstandingVB[i] = {
  //   off_rep_name: string,
  //   rep_data: [{
  //     rep_name: string,
  //     location: string,
  //     pending:  { [year]: number },   ← balance per year
  //     total_18_21: number,
  //     grand_total: number
  //   }]
  // }
  onlyOutstandingVB: any[] = [];

  constructor(
    private dialogRef: MatDialogRef<YeneBakiJahiratReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private cdr: ChangeDetectorRef,
    private datePipe: DatePipe
  ) { }

  ngOnInit(): void {
    this.reportType = this.data['reportType'];
    this.startDate = this.data['startDate'] || '';
    this.endDate = this.data['endDate'] || '';
    this.repName = this.data['repName'] || 'ALL';
    this.offRepName = this.data['offRepName'] || 'ALL';

    const req = {
      rep_name: this.repName,
      start_date: this.startDate,
      end_date: this.endDate,
      off_rep_name: this.offRepName,
      advt_name: this.data['name'] || 'ALL'
    };

    this.service.getBusinessOutstanding(req).subscribe({
      next: (response: any) => {
        // PHP returns { data: [...yearGroups], debug_raw: [...] }
        const actualData: any[] = response?.data ?? [];
        console.log('API raw data:', actualData);

        if (actualData.length > 0) {
          this.processData(actualData);
        } else {
          this.onlyOutstandingVB = [];
          this.allYears = [];
          this.earlyYears = [];
          this.recentYears = [];
        }

        this.isLoading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('API Error:', err);
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    });
  }

  // ─────────────────────────────────────────────────────────────────────────
  // processData
  //
  // PHP returns data YEAR-FIRST:
  //   [ { fin_year, off_rep_data: [ { off_rep_name, rep_data: [ { rep_name,
  //       advtdata: [ { contract_bal_amt } ] } ] } ] } ]
  //
  // We PIVOT to OFFREP-FIRST with pending amounts keyed by year:
  //   [ { off_rep_name, rep_data: [ { rep_name, pending:{year:bal},
  //                                   total_18_21, grand_total } ] } ]
  // ─────────────────────────────────────────────────────────────────────────
  // processData(rawData: any[]): void {

  //   // ── Step 1: collect & sort all financial years ───────────────────────────
  //   const yearSet = new Set<string>();
  //   rawData.forEach(yg => {
  //     const y = (yg.fin_year || '').trim();
  //     if (y) yearSet.add(y);
  //   });

  //   this.allYears = Array.from(yearSet).sort();
  //   const SPLIT_YEAR = '2021-22';                          // early / recent boundary
  //   this.earlyYears = this.allYears.filter(y => y < SPLIT_YEAR);
  //   this.recentYears = this.allYears.filter(y => y >= SPLIT_YEAR);

  //   // ── Step 2: pivot year-first → offRep-first using Maps ──────────────────
  //   const offRepMap = new Map<string, any>();

  //   rawData.forEach(yg => {
  //     const finYear = (yg.fin_year || '').trim();

  //     (yg.off_rep_data || []).forEach((off: any) => {
  //       const offName = (off.off_rep_name || 'Unassigned').trim();

  //       if (!offRepMap.has(offName)) {
  //         offRepMap.set(offName, {
  //           off_rep_name: offName,
  //           office_rep_mob: off.office_rep_mob || '',
  //           repMap: new Map<string, any>()
  //         });
  //       }
  //       const offEntry = offRepMap.get(offName);

  //       (off.rep_data || []).forEach((rep: any) => {
  //         const repKey = (rep.rep_name || 'Unassigned').trim();

  //         if (!offEntry.repMap.has(repKey)) {
  //           offEntry.repMap.set(repKey, {
  //             rep_name: repKey,
  //             rep_mob: rep.rep_mob || '',
  //             location: rep.location || '',
  //             pending: {} as Record<string, number>
  //           });
  //         }
  //         const repEntry = offEntry.repMap.get(repKey);

  //         // Sum unpaid balance for this rep under this fin year
  //         let yearBal = 0;
  //         (rep.advtdata || []).forEach((adv: any) => {
  //           yearBal += Number(adv.contract_bal_amt) || 0;
  //         });

  //         // Accumulate (safe if same rep appears across multiple year entries)
  //         repEntry.pending[finYear] = (repEntry.pending[finYear] || 0) + yearBal;
  //       });
  //     });
  //   });

  //   // ── Step 3: compute subtotals & flatten Maps → arrays ───────────────────
  //   this.onlyOutstandingVB = Array.from(offRepMap.values()).map(off => {

  //     const rep_data = Array.from(off.repMap.values()).map((rep: any) => {
  //       const total_18_21 = this.earlyYears
  //         .reduce((s: number, y: string) => s + (rep.pending[y] || 0), 0);

  //       const grand_total = this.allYears
  //         .reduce((s: number, y: string) => s + (rep.pending[y] || 0), 0);

  //       return { ...rep, total_18_21, grand_total };
  //     });

  //     return {
  //       off_rep_name: off.off_rep_name,
  //       office_rep_mob: off.office_rep_mob,
  //       rep_data
  //     };
  //   });

  //   console.log('Pivoted data:', this.onlyOutstandingVB);
  // }


  processData(rawData: any[]): void {

    // ── Step 1: collect & sort all financial years ───────────────────────────
    const yearSet = new Set<string>();
    rawData.forEach(yg => {
      const y = (yg.fin_year || '').trim();
      if (y) yearSet.add(y);
    });

    this.allYears = Array.from(yearSet).sort();
    const SPLIT_YEAR = '2021-22'; 
    this.earlyYears = this.allYears.filter(y => y < SPLIT_YEAR);
    this.recentYears = this.allYears.filter(y => y >= SPLIT_YEAR);

    // ── Step 2: pivot year-first → offRep-first using Maps ──────────────────
    const offRepMap = new Map<string, any>();

    rawData.forEach(yg => {
      const finYear = (yg.fin_year || '').trim();

      (yg.off_rep_data || []).forEach((off: any) => {
        const offName = (off.off_rep_name || 'Unassigned').trim();

        if (!offRepMap.has(offName)) {
          offRepMap.set(offName, {
            off_rep_name: offName,
            office_rep_mob: off.office_rep_mob || '',
            repMap: new Map<string, any>()
          });
        }
        const offEntry = offRepMap.get(offName);

        (off.rep_data || []).forEach((rep: any) => {
          const repKey = (rep.rep_name || 'Unassigned').trim();

          if (!offEntry.repMap.has(repKey)) {
            // ✅ FIX: Capture district from the rep level or the first advt record
            const districtVal = rep.advtdata && rep.advtdata.length > 0 
                                ? rep.advtdata[0].district 
                                : (rep.district || '');

            offEntry.repMap.set(repKey, {
              rep_name: repKey,
              rep_mob: rep.rep_mob || '',
              district: districtVal, // <--- Map PHP 'district' to this property
              pending: {} as Record<string, number>
            });
          }
          const repEntry = offEntry.repMap.get(repKey);

          // Sum unpaid balance for this rep under this fin year
          let yearBal = 0;
          (rep.advtdata || []).forEach((adv: any) => {
            yearBal += Number(adv.contract_bal_amt) || 0;
          });

          repEntry.pending[finYear] = (repEntry.pending[finYear] || 0) + yearBal;
        });
      });
    });

    // ── Step 3: compute subtotals & flatten Maps → arrays ───────────────────
    this.onlyOutstandingVB = Array.from(offRepMap.values()).map(off => {

      const rep_data = Array.from(off.repMap.values()).map((rep: any) => {
        const total_18_21 = this.earlyYears
          .reduce((s: number, y: string) => s + (rep.pending[y] || 0), 0);

        const grand_total = this.allYears
          .reduce((s: number, y: string) => s + (rep.pending[y] || 0), 0);

        // Ensure district is returned in the flattened object
        return { ...rep, total_18_21, grand_total };
      });

      return {
        off_rep_name: off.off_rep_name,
        office_rep_mob: off.office_rep_mob,
        rep_data
      };
    });

    console.log('Pivoted data with Districts:', this.onlyOutstandingVB);
  }

  // ── Office-rep column totals (for the totals row) ─────────────────────────
  getOffRepTotal(offRep: any, year: string): number {
    return (offRep.rep_data || [])
      .reduce((s: number, r: any) => s + (r.pending[year] || 0), 0);
  }

  getOffRepEarlyTotal(offRep: any): number {
    return this.earlyYears
      .reduce((s: number, y: string) => s + this.getOffRepTotal(offRep, y), 0);
  }

  getOffRepGrandTotal(offRep: any): number {
    return this.allYears
      .reduce((s: number, y: string) => s + this.getOffRepTotal(offRep, y), 0);
  }

  // ── Grand totals row (bottom of table) ───────────────────────────────────
  getGrandTotal(year: string): number {
    return this.onlyOutstandingVB
      .reduce((s: number, off: any) => s + this.getOffRepTotal(off, year), 0);
  }

  getGrandEarlyTotal(): number {
    return this.earlyYears
      .reduce((s: number, y: string) => s + this.getGrandTotal(y), 0);
  }

  getGrandOverallTotal(): number {
    return this.allYears
      .reduce((s: number, y: string) => s + this.getGrandTotal(y), 0);
  }

  exportExcel(fileName: string): void {
    const element = document.getElementById('print-section');
    if (!element) return;
    try {
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Outstanding Report');
      XLSX.writeFile(wb, `${fileName}.xlsx`);
    } catch (error) {
      console.error('Export Error:', error);
    }
  }


//   printPageA4Landscape(): void {
//     const printSection = document.getElementById('print-section');
//     if (!printSection) return;
//     const printWindow = window.open('', '', 'width=1400,height=900');
//     if (!printWindow) return;

//     printWindow.document.write(`
// <html>
//   <head>
//     <title>जाहिरात येणे बाकी अहवाल</title>
//     <style>
//       @page { size: A4 landscape; margin: 8mm; }

//       * {
//         -webkit-print-color-adjust: exact !important;
//         print-color-adjust: exact !important;
//         box-sizing: border-box;
//       }

//       body {
//         font-family: Arial, sans-serif;
//         font-size: 11px;
//         font-weight: bold;
//         color: #000;
//         background: #fff;
//         margin: 0;
//         padding: 0;
//       }

//       /* ── Report Header ──────────────────────────────────────── */
//       .report-header {
//         text-align: center !important;
//         margin-bottom: 10px;
//         border-bottom: 2px solid #000;
//         padding-bottom: 6px;
//       }
//       .report-header h2 {
//         font-size: 15px;
//         font-weight: 900;
//         margin: 0 0 4px 0;
//         text-align: center !important;
//         text-transform: uppercase;
//         letter-spacing: 1px;
//       }
//       .report-header p {
//         font-size: 11px;
//         font-weight: 700;
//         margin: 0;
//         text-align: center !important;
//       }

//       /* ── Table base ─────────────────────────────────────────── */
//       table {
//         border-collapse: collapse;
//         width: 100%;
//       }

//       th, td {
//         border: 1px solid #000;
//         padding: 4px 6px;
//         font-size: 11px;
//         font-weight: bold;
//         color: #000;
//         background: #fff;
//         vertical-align: middle;
//         white-space: nowrap;
//         /* DEFAULT: right-align everything (amounts) */
//         text-align: right;
//       }

//       /* ── Header row ─────────────────────────────────────────── */
//       thead th {
//         background: #fff !important;
//         font-weight: 900;
//         font-size: 11px;
//         text-align: center !important;
//         border: 2px solid #000;
//       }

//       /* ── First two columns (name + location) → LEFT align ───── */
//       td:first-child,
//       td:nth-child(2),
//       th:first-child,
//       th:nth-child(2) {
//         text-align: left !important;
//       }

//       /* ── Grey subtotal columns ──────────────────────────────── */
//       .grey-cell {
//         background: #e0e0e0 !important;
//         font-weight: 900;
//         border: 2px solid #000;
//         text-align: right !important;
//       }

//       /* ── Office rep header row ──────────────────────────────── */
//       .office-header-row td {
//         background: #d0d0d0 !important;
//         font-size: 12px;
//         font-weight: 900;
//         border: 2px solid #000;
//         padding: 5px 8px;
//         text-align: left !important;
//         text-transform: uppercase;
//         letter-spacing: 0.5px;
//       }

//       /* ── Office rep totals row ──────────────────────────────── */
//       .office-total-row td {
//         background: #b8b8b8 !important;
//         font-weight: 900;
//         border: 2px solid #000;
//         text-align: right !important;
//       }
//       .office-total-row td:first-child,
//       .office-total-row td:nth-child(2) {
//         text-align: left !important;
//       }

//       /* ── Grand total row ────────────────────────────────────── */
//       .grand-total-row td {
//         background: #fcfcfc !important;
//         color: #000 !important;
//         font-weight: 900;
//         font-size: 12px;
//         border: 2px solid #000;
//         text-align: right !important;
//       }
//       .grand-total-row td:first-child,
//       .grand-total-row td:nth-child(2) {
//         text-align: left !important;
//       }

//       /* ── Alternating data rows ──────────────────────────────── */
//       tbody tr:nth-child(even) td { background: #f5f5f5 !important; }
//       tbody tr:nth-child(odd)  td { background: #fff    !important; }

//       /* Special rows override alternating */
//       .office-header-row td { background: #f09b9b !important; }
//       .office-total-row  td { background: #8fecd8 !important; }
//       .grand-total-row   td { background: #ec83cd    !important; }

//       /* ── Hide action buttons ────────────────────────────────── */
//       .noPrint, .actions { display: none !important; }
//     </style>
//   </head>
//   <body>${printSection.outerHTML}</body>
// </html>
// `);

//     printWindow.document.close();
//     setTimeout(() => {
//       printWindow.print();
//       printWindow.close();
//     }, 500);
//   }


printPageA4Landscape(): void {
  const printSection = document.getElementById('print-section');
  if (!printSection) return;
  const printWindow = window.open('', '', 'width=1400,height=900');
  if (!printWindow) return;

  printWindow.document.write(`
<html>
  <head>
    <title>जाहिरात येणे बाकी अहवाल</title>
    <style>
      @page { size: A4 landscape; margin: 8mm; }

      * {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        box-sizing: border-box;
      }

      body {
        font-family: Arial, sans-serif;
        font-size: 11px;
        font-weight: normal;
        color: #000;
        background: #fff;
        margin: 0;
        padding: 0;
      }

      /* ── Report Header ──────────────────────────────────────── */
      .report-header {
        text-align: center !important;
        margin-bottom: 10px;
        border-bottom: 2px solid #000;
        padding-bottom: 6px;
      }
      .report-header h2 {
        font-size: 15px;
        font-weight: 900;
        margin: 0 0 4px 0;
        text-align: center !important;
        text-transform: uppercase;
        letter-spacing: 1px;
      }
      .report-header p {
        font-size: 11px;
        font-weight: 700;
        margin: 0;
        text-align: center !important;
      }

      /* ── Table base ─────────────────────────────────────────── */
      table {
        border-collapse: collapse;
        width: 100%;
        /* ✅ Fix 1 & 2: Fixed layout prevents table from spreading too wide */
        table-layout: fixed;
      }

      th, td {
        border: 1px solid #000;
        padding: 4px 6px;
        font-size: 11px;
        font-weight: normal;
        color: #000;
        background: #fff;
        vertical-align: middle;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        /* DEFAULT: right-align everything (amounts) */
        text-align: right;
      }

      /* ── Header row ─────────────────────────────────────────── */
      thead th {
        background: #fff !important;
        font-weight: 900;
        font-size: 11px;
        text-align: center !important;
        border: 2px solid #000;
      }

      /* ── First two columns (name + location) → LEFT align ───── */
      td:first-child,
      td:nth-child(2),
      th:first-child,
      th:nth-child(2) {
        text-align: left !important;
        /* ✅ Fix 2: Give name column enough width */
        min-width: 130px;
      }
      td:nth-child(2),
      th:nth-child(2) {
        min-width: 90px;
      }

      /* ── Grey subtotal columns ──────────────────────────────── */
      .grey-cell {
        background: #e0e0e0 !important;
        font-weight: 900;
        border: 2px solid #000;
        text-align: right !important;
      }

      /* ── Office rep header row ──────────────────────────────── */
      .office-header-row td {
        background: #f09b9b !important;
        font-size: 12px;
        font-weight: 900;
        border: 2px solid #000;
        padding: 5px 8px;
        text-align: left !important;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }

      /* ── Office rep totals row ──────────────────────────────── */
      .office-total-row td {
        background: #8fecd8 !important;
        font-weight: 900;
        border: 2px solid #000;
        /* ✅ Fix 7: Force right-align on ALL total cells including 2014-15 */
        text-align: right !important;
      }
      .office-total-row td:first-child,
      .office-total-row td:nth-child(2) {
        text-align: left !important;
      }

      /* ── Grand total row ────────────────────────────────────── */
      .grand-total-row td {
        background: #ec83cd !important;
        color: #000 !important;
        font-weight: 900;
        font-size: 12px;
        border: 2px solid #000;
        /* ✅ Fix 7: Force right-align on ALL grand total cells */
        text-align: right !important;
      }
      .grand-total-row td:first-child,
      .grand-total-row td:nth-child(2) {
        text-align: left !important;
      }

      /* ── ✅ Fix 3: Rep data rows — name NOT bold ─────────────── */
      .rep-data-row td {
        font-weight: normal !important;
        background: #fff;
      }
      .rep-data-row td.grey-cell {
        font-weight: 900 !important;
        background: #e0e0e0 !important;
      }

      /* ── Alternating data rows ──────────────────────────────── */
      tbody tr.rep-data-row:nth-child(even) td { background: #f5f5f5 !important; }
      tbody tr.rep-data-row:nth-child(odd)  td { background: #fff    !important; }
      /* grey-cell always stays grey even in alternating rows */
      tbody tr.rep-data-row td.grey-cell { background: #e0e0e0 !important; }

      /* ── Hide action buttons ────────────────────────────────── */
      .noPrint, .actions { display: none !important; }
    </style>
  </head>
  <body>${printSection.outerHTML}</body>
</html>
`);

  printWindow.document.close();
  setTimeout(() => {
    printWindow.print();
    printWindow.close();
  }, 500);
}

 formatCurrency(value: number | string | null | undefined): string {
  if (value === null || value === undefined) return '';
  const num = Number(value);
  if (isNaN(num) || num === 0) return '';
  return Math.round(num).toString(); // ← rounds off floating point garbage
}

getEarlyYearsLabel(): string {
  if (this.earlyYears.length === 0) return '';
  const startYear = this.earlyYears[0].split('-')[0];           // "2014" from "2014-15"
  const endPart   = this.earlyYears[this.earlyYears.length - 1].split('-')[1]; // "21" from "2020-21"
  return `${startYear}-${endPart}`;                             // "2014-21"
}


}